// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeTeamListBody = {
  leagueId: string;
};

export type typeTeamListOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    teams: {
      teamId: string;
      sportId: string;
      leagueId: string;
      teamKey: string;
      name: string;
      marketName: string;
      nickname: string;
      abbreviation: string;
      primaryColorHex?: string | null;
      secondaryColorHex?: string | null;
      venueId?: string | null;
      isActive: boolean;
      logoUrl?: string | null;
    }[];
  };
};

export type typeTeamListOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeTeamListOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeTeamListOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaTeamListBody = {
  type: "object",
  properties: { leagueId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["leagueId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createTeamList(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaTeamListBody);
  }

  return async function postTeamList(
    payload: typeTeamListBody,
  ): Promise<typeTeamListOutput200 | typeTeamListOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postTeamList" failed before calling the network. #df45712d668e`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#df45712d668e" },
        },
        data: null,
      } as typeTeamListOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/team/list`,
      httpMethod: "POST",
      options,
    })) as typeTeamListOutput200 | typeTeamListOutput400;
  };
}
